function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.insertNode0{fill:#FFBE54;}\n\t.insertNode1{fill:#37BEB7;}\n\t.insertNode2{fill:none;stroke:#16224A;stroke-width:50;stroke-miterlimit:10;}\n\t.insertNode3{fill:#16224A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode0",
  cx: 520.54,
  cy: 349.72,
  r: 97.33
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode1",
  cx: 168.55,
  cy: 519.86,
  r: 97.33
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode1",
  cx: 168.55,
  cy: 163.91,
  r: 97.33
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode2",
  cx: 141.31,
  cy: 141.2,
  r: 115.92
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "insertNode2",
  x1: 376.74,
  y1: 272.85,
  x2: 254.68,
  y2: 202.38
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode2",
  cx: 141.31,
  cy: 498.88,
  r: 115.92
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode2",
  cx: 498.1,
  cy: 327.59,
  r: 115.92
});

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "insertNode2",
  x1: 498.1,
  y1: 220.78,
  x2: 498.1,
  y2: 116.04
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "insertNode3",
  points: "552.95,132.09 498.1,37.1 443.25,132.09  "
}))));

var _ref11 = /*#__PURE__*/React.createElement("line", {
  className: "insertNode2",
  x1: 254.68,
  y1: 461.81,
  x2: 376.74,
  y2: 391.34
});

var SvgRemoveNode = function SvgRemoveNode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insertNode",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveNode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/removeNode.ce9eb1a1.svg";
export { ForwardRef as ReactComponent };